import React from "react";
import styled from "@emotion/styled";
import { Box, Card, Flex, useColorMode } from "theme-ui";
import { Text } from "theme-ui";
import { Page } from "state/global";
import { UserCircle, Planet } from "phosphor-react";
import { StyledLink } from "components/StyledLink";
import { NetworkDetails } from "components/Network/NetworkDetails";
import { PoofAccountGlobal } from "hooks/poofAccount";
import { CloseOnClickaway } from "components/CloseOnClickaway";
import { PoofAccountDetails } from "components/PoofAccount/PoofAccountDetails";
import { shortenAccount } from "utils/account";
import { useWeb3 } from "hooks/useWeb3";

const HoverDetails = styled(Box)<{ colorMode: string }>(({ colorMode }) => {
  return {
    position: "absolute",
    backgroundColor:
      colorMode === "dark"
        ? "var(--theme-ui-colors-secondaryBackground)"
        : "var(--theme-ui-colors-background)",
    padding: "12px",
    top: 60,
    right: 0,
    borderRadius: "6px",
    color: "var(--theme-ui-colors-primaryText)",
    border: "1px solid",
  };
});

export const AccountProfile: React.FC = () => {
  const { network } = useWeb3();
  const { poofAccount } = PoofAccountGlobal.useContainer();
  const [colorMode] = useColorMode();

  const [accountDetailsOpen, setAccountDetailsOpen] = React.useState(false);
  const [networkDetailsOpen, setNetworkDetailsOpen] = React.useState(false);

  const accountCard = React.useRef<HTMLDivElement>(null);
  const networkCard = React.useRef<HTMLDivElement>(null);

  return (
    <Flex sx={{ alignItems: "center" }}>
      <Box sx={{ position: "relative" }}>
        <Card
          ref={networkCard}
          sx={{ cursor: "pointer", mr: 3, height: 42, pl: 13, pr: 13 }}
          variant="warning"
          onClick={() => {
            setNetworkDetailsOpen(!networkDetailsOpen);
          }}
        >
          <Flex sx={{ alignItems: "center" }}>
            <Planet size={28} />
            <Text variant="primary" ml={2} mt={0}>
              {network.name}
            </Text>
          </Flex>
        </Card>
        {networkDetailsOpen && (
          <CloseOnClickaway
            onClickaway={(e) => {
              if (networkCard?.current?.contains(e.target)) {
                return;
              }
              setNetworkDetailsOpen(false);
            }}
          >
            <HoverDetails colorMode={colorMode}>
              <NetworkDetails />
            </HoverDetails>
          </CloseOnClickaway>
        )}
      </Box>

      <Box sx={{ position: "relative" }}>
        {poofAccount ? (
          <Card
            ref={accountCard}
            sx={{ cursor: "pointer", height: 42, pl: 13, pr: 13 }}
            variant="warning"
            onClick={() => {
              setAccountDetailsOpen(!accountDetailsOpen);
            }}
          >
            <Flex sx={{ alignItems: "center", color: "primaryText" }}>
              <UserCircle size={28} />
              <Text variant="primary" ml={2} mt={0}>
                {shortenAccount("0x" + poofAccount.address, 4)}
              </Text>
            </Flex>
          </Card>
        ) : (
          <StyledLink to={Page.SETUP} color="primaryText">
            Log in
          </StyledLink>
        )}
        {poofAccount && accountDetailsOpen && (
          <CloseOnClickaway
            onClickaway={(e) => {
              if (accountCard?.current?.contains(e.target)) {
                return;
              }
              setAccountDetailsOpen(false);
            }}
          >
            <HoverDetails colorMode={colorMode}>
              <PoofAccountDetails />
            </HoverDetails>
          </CloseOnClickaway>
        )}
      </Box>
    </Flex>
  );
};
